import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client, refreshWebsocketConnection } from './api';
import App from './App';
import 'antd/dist/reset.css';
import OnlineStatusManager from './components/OnlineStatusManager';
import { AuthProvider } from './components/AuthContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ApolloProvider client={client}>
    <AuthProvider>
      <Router>
        <OnlineStatusManager />
        <App />
      </Router>
    </AuthProvider>
  </ApolloProvider>
);
